import { ValidationArguments, ValidatorConstraintInterface, ValidatorConstraint } from 'class-validator';

@ValidatorConstraint({ name: 'IsValidAgentMaxCapacity' })
export class IsValidAgentMaxCapacity implements ValidatorConstraintInterface {
  validate(currentValue: number, args: ValidationArguments) {
    const { object } = args;
    return currentValue >= 1 && currentValue >= object['agentCapacity'];
  }

  defaultMessage() {
    return 'Please enter a value greater than or equal to the agent capacity';
  }
}
